import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./store/auth";
import settings from "./store/settings";
import agGrid from "./store/agGrid";
import users from "./store/users";
import scheduledSurveys from "./store/scheduledSurveys";
import organizations from "./store/organizations";
import surveyReports from "./store/surveyReports";
import trailers from "./store/trailers";
import deviceController from "./store/deviceController";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    agGrid,
    users,
    scheduledSurveys,
    organizations,
    surveyReports,
    trailers,
    deviceController
  },
  plugins: [
    createPersistedState({
      paths: [
        "auth",
        "settings",
        "agGrid",
        "users",
        "organizations",
        "trailers"
      ]
    })
  ]
});
